import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from '../../../../constants';

export const useStyles = makeStyles(theme =>
  createStyles({
    // ========================================
    // DESKTOP WIZARD LAYOUT
    // ========================================
    wizardContainer: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      height: '100%',
      backgroundColor: STYLE.COLOR.WHITE,
    },

    contentContainer: {
      display: 'flex',
      width: '100%',
      overflowY: 'auto',
      justifyContent: 'center',
      alignItems: 'flex-start',
      paddingRight: '24px',
      paddingLeft: '494px',
      paddingTop: '103px',
      paddingBottom: '32px',
      '@media (max-width: 1024px)': {
        paddingLeft: '344px',
        paddingTop: '103px',
      },
    },

    contentContainerWithWarning: {
      paddingTop: '143px',
      '@media (max-width: 1024px)': {
        paddingTop: '143px',
      },
    },

    content: {
      maxWidth: '674px',
      width: '100%',
      flexDirection: 'column',
      margin: '0 auto',
    },

    // ========================================
    // DESKTOP SIDEBAR
    // ========================================
    sidebar: {
      maxWidth: '470px',
      width: '100%',
      padding: '24px',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: STYLE.COLOR.BACKGROUND_LIGHT,
      borderRadius: '0 32px 32px 0',
      overflowY: 'auto',
      position: 'fixed',
      left: 0,
      top: 0,
      bottom: 0,
      '@media (max-width: 1024px)': {
        maxWidth: '320px',
      },
    },
    sidebarHeader: {
      marginBottom: '32px',
    },
    sidebarTitle: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 600,
      color: STYLE.COLOR.TEXT1,
      marginBottom: '2px',
    },
    sidebarSubtitle: {
      fontSize: '12px',
      lineHeight: '18px',
      color: STYLE.COLOR.TEXT2,
      fontWeight: 400,
    },
    sidebarSteps: {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      '& > div + div': {
        marginTop: '20px',
      },
    },
    sidebarStep: {
      display: 'flex',
      cursor: 'pointer',
      position: 'relative',
      '&:before': {
        position: 'absolute',
        content: '""',
        left: '16px',
        top: '36px',
        bottom: 0,
        width: '1px',
        backgroundColor: STYLE.COLOR.ACCENT_PRIMARY,
        height: 'calc(100% - 19px)',
        minHeight: '14px',
      },
      '&:last-child': {
        '&:before': {
          display: 'none',
        },
      },
    },
    sidebarStepCenter: {
      alignItems: 'center',
      '&:before': {
        height: 'inherit',
      },
    },
    sidebarStepActive: {
      cursor: 'default',
    },
    noCursor: {
      cursor: 'default',
    },
    sidebarStepDisabled: {
      cursor: 'not-allowed',
      opacity: 0.5,
    },
    stepIcon: {
      marginRight: '12px',
      display: 'flex',
      zIndex: 2,
    },
    stepTitleParent: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
    },
    stepTitle: {
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: 500,
      color: STYLE.COLOR.TEXT1,
    },
    stepTitleCompleted: {
      color: STYLE.COLOR.TEXT2,
    },
    stepTitleActive: {
      color: STYLE.COLOR.ACCENT_PRIMARY,
    },
    stepFields: {
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'column',
      marginTop: '4px',
      '& > div + div': {
        marginTop: '4px',
      },
    },
    fieldContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
    },
    field: {
      fontSize: '12px',
      lineHeight: '18px',
      color: STYLE.COLOR.TEXT2,
      fontWeight: 400,
    },
    fieldIcon: {
      width: '11px',
      height: '11px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      cursor: 'pointer',
    },
    tooltipPopper: {
      zIndex: 1500,
    },
    tooltip: {
      backgroundColor: '#000000 !important',
      opacity: 1,
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '16px',
      color: '#FFFFFF',
      padding: '8px',
      borderRadius: '4px',
      maxWidth: '200px',
    },
    tooltipArrow: {
      color: '#000000',
    },

    // ========================================
    // MOBILE WIZARD LAYOUT
    // ========================================
    mobileWizardContainer: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      maxWidth: '100vw',
      height: '100vh',
      overflowX: 'hidden',
      boxSizing: 'border-box',
    },

    // ========================================
    // MOBILE NAVIGATION
    // ========================================
    mobileNavBar: {
      backgroundColor: STYLE.COLOR.BACKGROUND_LIGHT,
      // borderRadius: '12px',
      overflow: 'hidden',
      position: 'fixed',
      top: '61px',
      left: 0,
      right: 0,
      // left: '15px',
      // right: '15px',
      zIndex: 11,
      flexShrink: 0,
    },

    mobileBackdrop: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      zIndex: 10,
      cursor: 'pointer',
    },

    mobileNavHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '20px 24px 16px',
      cursor: 'pointer',
      WebkitTapHighlightColor: 'transparent',
      touchAction: 'manipulation',
      userSelect: 'none',
      '&:active': {
        backgroundColor: 'transparent',
      },
      '&:focus': {
        outline: 'none',
      },
    },

    mobileCurrentStepIndicator: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
    },

    mobileCurrentStepIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    mobileCurrentStepTitle: {
      fontSize: '14px',
      lineHeight: '24px',
      fontWeight: 500,
      color: STYLE.COLOR.ACCENT_PRIMARY,
    },

    mobileExpandIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& svg': {
        width: '20px',
        height: '20px',
        color: STYLE.COLOR.TEXT2,
      },
    },

    // ========================================
    // MOBILE EXPANDED NAVIGATION
    // ========================================
    mobileExpandedNavigation: {
      padding: '6px 24px',
      backgroundColor: STYLE.COLOR.BACKGROUND_LIGHT,
      marginBottom: '20px',
    },

    mobileHeaderDivider: {
      width: 'calc(100% - 48px)',
      height: '1px',
      backgroundColor: STYLE.COLOR.STROKE_DEFAULT,
      margin: '0 24px',
    },

    mobileNavigationSteps: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0px',
    },

    // ========================================
    // MOBILE NAVIGATION STEPS
    // ========================================
    mobileStepWithConnector: {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
    },

    mobileStepConnector: {
      position: 'absolute',
      left: '8px',
      bottom: '-8px',
      width: '1px',
      height: '16px',
      backgroundColor: STYLE.COLOR.ACCENT_PRIMARY,
      zIndex: 1,
      borderRadius: '50px',
    },

    mobileNavigationStep: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: '10px 0', // Increased padding for better spacing
      cursor: 'pointer',
      borderRadius: '8px',
      transition: 'background-color 0.2s ease',
      position: 'relative',
      zIndex: 2,

      '&:hover': {
        backgroundColor: STYLE.COLOR.WHITE,
      },
    },

    mobileNavigationStepActive: {
      cursor: 'default',

      '&:hover': {
        backgroundColor: 'transparent',
      },
    },

    mobileNavigationStepInactive: {
      // Default styles for inactive steps
    },

    mobileNavigationStepDisabled: {
      cursor: 'not-allowed',
      // opacity: 0.3,

      '&:hover': {
        backgroundColor: 'transparent',
      },
    },

    // ========================================
    // MOBILE STEP ICONS
    // ========================================
    mobileStepIconContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    mobileStepIconCircle: {
      width: '18px',
      height: '18px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: `${STYLE.COLOR.ACCENT_PRIMARY}33`,
    },

    mobileStepIconCircleFilled: {
      width: '20px',
      height: '20px',
      borderRadius: '50%',
      backgroundColor: STYLE.COLOR.ACCENT_PRIMARY,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: 'none',
    },

    mobileStepIconDot: {
      width: '6px',
      height: '6px',
      borderRadius: '50%',
      backgroundColor: STYLE.COLOR.ACCENT_PRIMARY,
    },

    regularStepWrapper: {
      width: '18px',
      height: '18px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    regularMobileStepIconDot: {
      width: '10px',
      height: '10px',
      borderRadius: '50%',
      backgroundColor: `${STYLE.COLOR.ACCENT_PRIMARY}33`,
    },

    // ========================================
    // MOBILE STEP TITLES
    // ========================================
    mobileStepTitleContainer: {
      flex: 1,
    },

    mobileStepTitle: {
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: 500,
      margin: 0,
    },

    mobileStepTitleActive: {
      color: STYLE.COLOR.ACCENT_PRIMARY,
    },

    mobileStepTitleDisabled: {
      color: STYLE.COLOR.TEXT2,
    },

    // ========================================
    // MOBILE CONTENT AREA
    // ========================================
    mobileContentContainer: {
      display: 'flex',
      width: '100%',
      flex: 1,
      paddingTop: '152px',
      paddingLeft: '16px',
      paddingRight: '16px',
      overflowX: 'hidden',
      backgroundColor: STYLE.COLOR.WHITE,
      WebkitOverflowScrolling: 'touch',
      height: 'calc(100vh - 100px)',
      boxSizing: 'border-box',
      paddingBottom: '100px',
    },

    mobileContentContainerWithWarning: {
      paddingTop: '192px',
    },

    mobileContent: {
      width: '100%',
      maxWidth: '100%',
      display: 'flex',
      flexDirection: 'column',
      minHeight: 'fit-content',
      boxSizing: 'border-box',

      '& *': {
        boxSizing: 'border-box',
        // maxWidth: '100%',
      },
    },

    // ========================================
    // Header
    // ========================================

    header: {
      width: '100%',
      maxWidth: 'calc(100% - 470px)',
      '@media (max-width: 1024px)': {
        maxWidth: 'calc(100% - 320px)',
      },
      '@media (max-width: 767px)': {
        maxWidth: '100%',
      },
    },
  }),
);

export const useStylesForContentHeader = makeStyles(theme =>
  createStyles({
    parent: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
    title: {
      fontSize: '32px',
      lineHeight: '140%',
      fontWeight: 600,
      color: STYLE.COLOR.BLACK,
      marginBottom: '4px',
      '@media (max-width: 768px)': {
        fontSize: '24px',
        lineHeight: '32px',
      },
      '@media (max-width: 600px)': {
        fontSize: '16px',
        lineHeight: '24px',
      },
    },
    subtitle: {
      fontSize: '16px',
      lineHeight: '24px',
      color: STYLE.COLOR.TEXT2,
      fontWeight: 400,
      '@media (max-width: 600px)': {
        fontSize: '14px',
        lineHeight: '24px',
      },
    },
  }),
);
